import { render, staticRenderFns } from "./CollapseMenuIcon.vue?vue&type=template&id=72477ef4&scoped=true&"
import script from "./CollapseMenuIcon.vue?vue&type=script&lang=ts&"
export * from "./CollapseMenuIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72477ef4",
  null
  
)

export default component.exports